import { render, staticRenderFns } from "./ConfirmDevelopmentGoal.vue?vue&type=template&id=25e0c0dc&lang=html&"
import script from "./ConfirmDevelopmentGoal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDevelopmentGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports